<h3 mat-dialog-title>
  <div class="modal-header">
    <img src="./../assets/images/logos/accept-logo.png" height="40px" alt="Logo">
    <span class="fx-spacer"></span>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</h3> 

<mat-dialog-content *ngIf="isLoading; else content">
  <!-- <mat-spinner></mat-spinner> -->
</mat-dialog-content>

<ng-template #content>
  <h3>{{'app.smartness-scores-domains' | translate}}:</h3>
  <ul>
    <li *ngFor="let domain of pilotData['Smartness Scores'].Domains[0] | keyvalue">
      <span>{{ domain.key }}: </span>
      <strong>{{ domain.value }} </strong>
      <span>(Avg Pilot Value: {{ getComparisonValueForDomain(domain.key) }})</span>
    </li>
  </ul>

  <h3>{{'app.smartness-scores-impact-criteria' | translate}}:</h3>
  <ul>
    <li *ngFor="let impact of pilotData['Smartness Scores']['Impact_criteria'][0] | keyvalue">
      <span>{{ impact.key }}: </span>
      <strong>{{ impact.value }} </strong>
      <span>(Avg Pilot Value: {{ getComparisonValueForImpact(impact.key) }})</span>
    </li>
  </ul>

  <p>{{'app.total-sri-score' | translate}}:
    <strong>{{ pilotData['Smartness Scores']['Total_SRI_Score'] }} </strong>
    <span>(Avg Pilot Value: {{ getTotalSRIComparison() }})</span>
  </p>
</ng-template>

<mat-dialog-actions class="d-flex justify-content-center">
  <div class="close-button">
    <button class="btn bg-green text-white" (click)="close()">
      {{'app.ok' | translate}}
    </button>
  </div>
</mat-dialog-actions>